"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGenerateGenders = void 0;
var react_1 = require("react");
var next_intl_1 = require("next-intl");
var useGenerateGenders = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    return (0, react_1.useMemo)(function () { return [
        { label: t('male'), value: 'male' },
        { label: t('female'), value: 'female' },
    ]; }, [t]);
};
exports.useGenerateGenders = useGenerateGenders;
